/*
 * Copyright (c) Microsoft Corporation. All rights reserved. Licensed under the MIT license.
 * See LICENSE in the project root for license information.
 */
import axios from "axios";
const keyHexString = "pG3JjX8QriIeyfLwea5Ke/hamDIQq9sqKbZL0gdlRlI=";

/* global document, Office, Word */
const favDialog = document.getElementById("favDialog");
const comapnyDialog = document.getElementById("companyDialog");
const categoriesDialog = document.getElementById("categoriesDialog");
const selectComapny = document.getElementById("dropdown");
const selectCompanyBtn = document.getElementById("selectCompanyBtn");
// const outputBox = document.querySelector("output");
// const selectEl = favDialog.querySelector("select");
// const confirmBtn = favDialog.querySelector("#confirmBtn");
const uploadBody = document.getElementById("upload-body");
const loginBody = document.getElementById("login-body");
const loginButton = document.getElementById("login-button");
let hostValue = "";
let usernameValue = "";
let passwordValue = "";
let comanyValue = "";
Office.onReady((info) => {
  if (info.host === Office.HostType.Excel) {
    // document.getElementById("sideload-msg").style.display = "none";
    document.getElementById("app-body").style.display = "flex";
    document.getElementById("run").onclick = run;
  }
  var userdata = localStorage.getItem("Xplore");
  if (userdata === null) {
    uploadBody.style.display = "none";
    loginBody.style.display = "block";
  } else {
    // There is data stored under the key "username"

    const decryptedData = decrypt(userdata, keyHexString);
    hostValue = decryptedData.host;
    usernameValue = decryptedData.username;
    passwordValue = decryptedData.password;
    comanyValue = decryptedData.company;
    uploadBody.style.display = "block";
    loginBody.style.display = "none";
  }
});

export async function run() {
  try {
    await Excel.run(async (context) => {
      /**
       * Insert your Excel code here
       */
      // const range = context.workbook.getSelectedRange();

      // // Read the range address
      // range.load("address");

      // // Update the fill color
      // range.format.fill.color = "yellow";
      // document.getElementById("error-message-header").textContent = "Uploading!";
      // document.getElementById("error-message").textContent = "Uploading the File.";
      // favDialog.showModal();
      await getCurrentFile();
      await context.sync();
      // console.log(`The range address was ${range.address}.`);
    });
  } catch (error) {
    console.error(error);
  }
}
async function getCurrentFile() {
  console.log('pressed');
  const button = document.getElementById("run");
  button.disabled = true;
  button.textContent = "Uploading";
  button.style.backgroundColor = "gray";
 
  await Office.context.document.getFileAsync(Office.FileType.Pdf, async function (result) {

    if (result.status == "succeeded") {

      var myFile = result.value;
      var sliceCount = myFile.sliceCount;
      let fileContent = new Uint8Array();

      for (let i = 0; i < sliceCount; i++) {
        const sliceResult = await new Promise((resolve) => {
          myFile.getSliceAsync(i, (result) => {
            resolve(result);
          });
        });
        if (sliceResult.status === "succeeded") {
          const slice = sliceResult.value.data;
          const sliceArray = new Uint8Array(slice);
          fileContent = concatenateArrays(fileContent, sliceArray);
        } else {
          document.getElementById("error-message-header").textContent = "Error!";
          document.getElementById("error-message").textContent = "Error in convert file!";
          favDialog.showModal();
          button.disabled = false;
          button.textContent = "Upload";
          button.style.backgroundColor ="#04AA6D";

          return;
        }
      }

      const fileUrl = Office.context.document.url.split("\\");

      const file = new File([fileContent], fileUrl[fileUrl.length - 1], { type: "xlsx" });
      var userdata = localStorage.getItem("Xplore");
      if (userdata === null) {
        // There is no data stored under the key "username"
        // favDialog.showModal();
        uploadBody.style.display = "none";
        loginBody.style.display = "block";
      } else {
        // There is data stored under the key "username"

        const decryptedData = decrypt(userdata, keyHexString);
        hostValue = decryptedData.host;
        usernameValue = decryptedData.username;
        passwordValue = decryptedData.password;
        comanyValue = decryptedData.company;
        uploadBody.style.display = "block";
        loginBody.style.display = "none";
      }
      loginRequest(hostValue, usernameValue, passwordValue).then(
        (result) => {
          if (result.status === 200) {
            let data = result.data;
            let token = "";
            let company = comanyValue;
            for (const key in data) {
              if (Object.hasOwnProperty.call(data, key)) {
                if (key == "message") {
                  return;
                }
                const value = data[key];
                // if (key == "company_users") {
                //   for (const key2 in value[0]) {
                //     if (Object.hasOwnProperty.call(data, key)) {
                //       if (key2 == "company") {
                //         company = value[0][key2];
                //       }
                //     }
                //   }
                // }
                if (key == "token") {
                  for (const key2 in value) {
                    if (Object.hasOwnProperty.call(data, key)) {
                      if (key2 == "access") {
                        token = "Bearer " + value[key2];
                      }
                    }
                  }
                }
              }
            }
            uploadFileRequest(hostValue, file, company, token).then((uploadReslt) => {
              if (uploadReslt.status === 200) {
                indexFileRequest(hostValue, uploadReslt.data, company, token).then((indexReslt) => {
                  if (indexReslt.status === 200){
                    document.getElementById("error-message-header").textContent = "Success!";
                    document.getElementById("error-message").textContent = "File Uploaded Successfully.";
                    favDialog.showModal();
                    button.disabled = false;
                    button.textContent = "Upload";
                    button.style.backgroundColor ="#04AA6D";



                  }else{
                    document.getElementById("error-message-header").textContent = "Error!";
                    document.getElementById("error-message").textContent = indexReslt;
                    favDialog.showModal();
                    button.disabled = false;
                    button.textContent = "Upload";
                    button.style.backgroundColor ="#04AA6D";


                  }
                });
              } else {
                document.getElementById("error-message-header").textContent = "Error!";
                document.getElementById("error-message").textContent = uploadReslt;
                favDialog.showModal();
                button.disabled = false;
                button.textContent = "Upload";
                button.style.backgroundColor ="#04AA6D";


              }
            });
          } else {
            document.getElementById("error-message-header").textContent = "Error!";

            document.getElementById("error-message").textContent = result;
            favDialog.showModal();
            button.disabled = false;
            button.textContent = "Upload";
            button.style.backgroundColor ="#04AA6D";


          }
        },
        (reason) => {
          document.getElementById("error-message").textContent = reason;
          favDialog.showModal();
          button.disabled = false;
          button.textContent = "Upload";
          button.style.backgroundColor ="#04AA6D";


        }
      );
      myFile.closeAsync();
    } else {
      document.getElementById("error-message-header").textContent = "Error!";

      document.getElementById("error-message").textContent = result;
      favDialog.showModal();
      button.disabled = false;
      button.textContent = "Upload";
      button.style.backgroundColor ="#04AA6D";


    }
  });
}
function concatenateArrays(arr1, arr2) {
  var result = new Uint8Array(arr1.length + arr2.length);
  result.set(arr1);
  result.set(arr2, arr1.length);
  return result;
}
async function loginRequest(host, username, password) {
  try {
    const data = {
      username: username,
      password: password,
    };
    const request = await axios.post(`${host}/users/login`, data, {
      headers: {
        "Content-Type": "application/json",
      },
    });

    return request;
  } catch (error) {
    return "Unable to login with provided credentials.";
  }
}
async function getCategories(host, company, token){
  try {
    const request = await axios.get(`${host}/search/attachments/categories`, {
      headers: {
        "Content-Type": "application/json",
        company: company,
        Authorization: token,
      },
    });
    return request;
  } catch (error) {
    return error;
  }
}
async function uploadFileRequest(host, file, company, token) {
  try {
    const formData = new FormData();
    formData.append("file", file);
    const request = await axios.post(`${host}/index/upload`, formData, {
      headers: {
        "Content-Type": "application/json",
        company: company,
        Authorization: token,
      },
    });
    return request;
  } catch (error) {
    return error;
  }
}
async function indexFileRequest(host, keys, company, token) {
  try {
    const request = await axios.post(`${host}/index/index`, keys, {
      headers: {
        "Content-Type": "application/json",
        company: company,
        Authorization: token,
      },
    });

    return request;
  } catch (error) {
    return error;
  }
}
loginButton.addEventListener("click", () => {
  const hostnameText = document.getElementById("hostText").value;
  const usernameText = document.getElementById("usernameText").value;
  const passwordText = document.getElementById("passwordText").value;
  if (!isStringValid(hostnameText) || !isStringValid(usernameText) || !isStringValid(passwordText)) {
    document.getElementById("error-message-header").textContent = "Error!";

    document.getElementById("error-message").textContent = "Please Fill Empty Fields";
    favDialog.showModal();
  } else {
    loginRequest(hostnameText, usernameText, passwordText).then(
      (result) => {
        if (result.status === 200) {
          hostValue = hostnameText;
          usernameValue = usernameText;
          passwordValue = passwordText;
          if(result.data.company_users){
            let companyID;
            if(result.data.company_users.length > 1){
              // var dropdown = document.getElementById("dropdown");
              // for (const company of result.data.company_users) {
              //   const optionElement = document.createElement("option");
              //   optionElement.value = company.company;
              //   optionElement.textContent = company.company_name;
              //   dropdown.appendChild(optionElement);
              // }
              // comapnyDialog.showModal();
              // companyID = dropdown.options[dropdown.selectedIndex].value;
              openDialog(result.data.company_users);
            }else{
              companyID = result.data.company_users[0].company;
              const userdata = { host: hostValue, username: usernameValue, password: passwordValue, company:companyID };
              const encryptedData = encrypt(userdata, keyHexString);
              localStorage.setItem("Xplore", encryptedData);
              uploadBody.style.display = "block";
              loginBody.style.display = "none";
              location.reload();

            }
            

          }else{
            document.getElementById("error-message-header").textContent = "Error!";

            document.getElementById("error-message").textContent = "User not assigned to any company";
            favDialog.showModal();
          }
       
          // const userdata = { host: hostnameText, username: usernameText, password: passwordText,company:companyID };
          // const encryptedData = encrypt(userdata, keyHexString);
          // localStorage.setItem("Xplore", encryptedData);
          // uploadBody.style.display = "block";
          // loginBody.style.display = "none";
        } else {
          document.getElementById("error-message-header").textContent = "Error!";

          document.getElementById("error-message").textContent = result;
          favDialog.showModal();
        }
      },
      (reason) => {
        document.getElementById("error-message-header").textContent = "Error!";

        document.getElementById("error-message").textContent = reason;
        favDialog.showModal();
      }
    );
  }
});
function openDialog(array) {
  var dialog = document.getElementById("dialog");
  var dropdown = document.getElementById("dropdown");
  dialog.showModal();
  // Clear existing options
  dropdown.innerHTML = "";

  // Populate dropdown with values from the array
  for (var i = 0; i < array.length; i++) {
    var option = document.createElement("option");
    option.value = array[i].company;
    option.textContent = array[i].company_name;
    // option.text = array[i];
    dropdown.add(option);
  }

  dialog.style.display = "block";
}
var loginButtons = document.getElementById("loginButtons");
loginButtons.addEventListener("click", () => {
  var dropdown = document.getElementById("dropdown");
  var selectedValue = dropdown.options[dropdown.selectedIndex].value;
  const userdata = { host: hostValue, username: usernameValue, password: passwordValue, company:selectedValue };
  const encryptedData = encrypt(userdata, keyHexString);
  localStorage.setItem("Xplore", encryptedData);
  var dialog = document.getElementById("dialog");
  dialog.style.display = "none";
  uploadBody.style.display = "block";
  loginBody.style.display = "none";
  location.reload();

 
});
function printSelectedValue() {
  
}
function isStringValid(str) {
  return typeof str === "string" && str.trim() !== "";
}

function encrypt(o, salt) {
  o = JSON.stringify(o).split("");
  for (var i = 0, l = o.length; i < l; i++)
    if (o[i] == "{") o[i] = "}";
    else if (o[i] == "}") o[i] = "{";
  return encodeURI(salt + o.join(""));
}

function decrypt(o, salt) {
  o = decodeURI(o);
  if (salt && o.indexOf(salt) != 0) throw new Error("object cannot be decrypted");
  o = o.substring(salt.length).split("");
  for (var i = 0, l = o.length; i < l; i++)
    if (o[i] == "{") o[i] = "}";
    else if (o[i] == "}") o[i] = "{";
  return JSON.parse(o.join(""));
}